import { useDocumentChatContext } from '@/modules/chat/contexts/DocumentChatProvider';
import { SideDrawer } from '@/modules/common/SideDrawer';
import { THEME_SHADOWS } from '@/styles/themes/common';
import { COLORS } from '@/styles/tokens/colors';

import { CHAT_WIDTH } from '../../common/Chat/ChatPane/Chat.constants';
import { DocumentChatHeader } from './DocumentChatHeader';
import { DocumentChatShell } from './DocumentChatShell';

export interface DocumentChatDrawerProps {
  enableCopyCitationPopover?: boolean;
}

export function DocumentChatDrawer({
  enableCopyCitationPopover = false,
}: DocumentChatDrawerProps) {
  const { closeChat } = useDocumentChatContext();

  return (
    <SideDrawer
      width={CHAT_WIDTH}
      isOpen={true}
      onClose={closeChat}
      heading={<DocumentChatHeader />}
      body={
        <DocumentChatShell
          enableCopyCitationPopover={enableCopyCitationPopover}
        />
      }
      bodyPropsSx={{ p: 0 }}
      hideBackdrop
      headerProps={{
        sx: { p: 0, pr: 2 },
        borderBottom: `solid 1px ${COLORS.GRAY[200]}`,
      }}
      drawerPropsSx={{
        boxShadow: `${THEME_SHADOWS.lg}`,
      }}
    />
  );
}
